import { render, staticRenderFns } from "./AuthRecordList.vue?vue&type=template&id=5ac818ae&"
import script from "./AuthRecordList.vue?vue&type=script&lang=js&"
export * from "./AuthRecordList.vue?vue&type=script&lang=js&"
import style0 from "./AuthRecordList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports